const LIST_QUERY = `
  query ListSchedule($paginationParams: PaginationInput!) {
    listSchedules(pagination: $paginationParams) {
      objects {
        uuid,
        startTime,
        endTime,
      }
      totalRows
    }
  }
`

const CREATE_SCHEDULE = `
  mutation CreateSchedule($startTime: String!, $endTime: String!) {
    createSchedule(params: {
      name: "Two-Factor Authentication Schedule",
      description: "Time at which two-factor will be enabled.",
      startTime: $startTime,
      endTime: $endTime,
    }) {
      uuid,
      startTime,
      endTime
    }
  }
`

const UPDATE_MUTATION = `
  mutation UpdateSchedule(
    $uuid: String!,
    $startTime: String!,
    $endTime: String!
  ) {
    updateSchedule(params: {
      uuid: $uuid
      startTime: $startTime,
      endTime: $endTime,
    }) {
      uuid,
      startTime,
      endTime
    }
  }
`

const DELETE_MUTATION = `
  mutation DeleteSchedule($uuid: String!) {
    deleteSchedule(uuid: $uuid)
  }
`

const scheduleQueries = {
  methods: {
    async listSchedulesQuery(paginationParams) {
      try {
        const result = await this.graphQuery(LIST_QUERY, {paginationParams})
        const {objects: scheduleList, totalRows} = result.listSchedules
        return {scheduleList, totalRows}
      } catch (error) {
        throw new Error(error)
      }
    },
    async createScheduleMutation(schedule) {
      try {
        const result = await this.graphQuery(CREATE_SCHEDULE, schedule)
        return result.createSchedule
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateScheduleMutation(schedule) {
      try {
        const result = await this.graphQuery(UPDATE_MUTATION, schedule)
        return result.updateSchedule
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteScheduleMutation(schedule) {
      try {
        const result = await this.graphQuery(DELETE_MUTATION, schedule)
        return result.deleteSchedule
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default scheduleQueries
